<div class="wrapper">
  <div class="labelContainer">
    <div class="label">{{'player.nowplaying' | translate}}</div>
  </div>
  <div class="titleContainer">
    <tun-scrollable-text class="title" [text]="originTitle$ | async"></tun-scrollable-text>
  </div>

</div>
